import Vue from 'vue';
import countries from '@/utils/countries';
const { $gettext } = Vue.prototype;
export default {
defaultCustomer: {
  name: '',
  url: '',
  adminAccount: '',
  adminPassword: '',
},
form(customer) {
  const { getters } = Vue.prototype.store;
  return [
    [
      {
        fieldName: 'name',
        text: $gettext('Company Name'),
        rules: 'required',
      },
      {
        fieldName: 'contactPerson',
        text: $gettext('Contact Person Name'),
      },
      {
        fieldName: 'email',
        text: $gettext('Email'),
      },
      {
        fieldName: 'phone',
        text: $gettext('Phone'),
      },
      {
        fieldName: 'country',
        text: $gettext('Country'),
        type: 'select',
        items: countries
      },
      {
        fieldName: 'url',
        text: $gettext('Url'),
        rules: 'required',
        suffix: '.' + process.env.VUE_APP_DEPLOY_DOMAIN
      },
      {
        fieldName: 'adminAccount',
        text: $gettext('Admin Username'),
        rules: 'required',
      },
      {
        fieldName: 'adminPassword',
        text: $gettext('Admin Password'),
        rules: 'required',
      },
      {
        fieldName: 'masterDatabase',
        text: $gettext('Master Database'),
        type: 'select',
        items: [
          {
            id: 'data.sql',
            name: $gettext('Thailand Master Database')
          },
          {
            id: 'data-us.sql',
            name: $gettext('USA Master Database')
          }
        ],
      },
    ],
  ];
}
};